import { isAndroid, isIOS, isMobileOnly, isWinPhone } from 'react-device-detect';
import React from 'react';
import {
  TooltipItem,
} from 'shared/components';

const ShipmentListItem = ({
  item,
}) => {
  const {
    shippedDate,
    shipmentTrackingId,
    contactName,
    address1,
    address2,
    city,
    state,
    zip,
  } = item;
  const target = isMobileOnly && isAndroid && isWinPhone && isIOS ? '' : '_blank';
  return (
    <div className="shipment-table-item">
      <div>{shippedDate}</div>
      <a
        href={ `https://www.fedex.com/fedextrack/?trknbr=${shipmentTrackingId}` }
        className="text-bold text-pacific-blue"
        target={target}>
        {shipmentTrackingId}
      </a>
      <TooltipItem item={contactName}/>
      <TooltipItem item={address1}/>
      <TooltipItem item={address2}/>
      <TooltipItem item={city}/>
      <div>
        {state}
      </div>
      <div>
        {zip}
      </div>
    </div>
  );
};

export default ShipmentListItem;
